import {
   LastMedicalTreatmentConsentQuery,
   MedicalTreatmentConsent,
   Patient,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsFind, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useLastMedicalTreatmentConsentQuery = (
   patientId: Patient['id']
): UseCqrsQueryResult<MedicalTreatmentConsent | null> => {
   return useCqrsFind(() => {
      const query = new LastMedicalTreatmentConsentQuery();
      query.patientId = patientId;
      return query;
   });
};
